export default "__VITE_ASSET__C1HasnS0__"